export default [
    {
        path: '/app/coupon/list.html',
        component: (resolve) => require(['@/view/app/coupon/index.vue'],resolve),
    },
    {
        path: '/app/coupon/add.html',
        component: (resolve) => require(['@/view/app/coupon/add.vue'],resolve),
    },
    {
        path: '/app/coupon/receive/list.html',
        component: (resolve) => require(['@/view/app/coupon/receive/index.vue'],resolve),
    },
]
